// Active event selection — simple Zustand store + localStorage persistence.
// Cashiers pick which event they're currently working on. Persists per-device.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveEventState {
  activeEventId: string | null;
  activeEventName: string | null;
  setActiveEvent: (id: string | null, name?: string) => void;
  clear: () => void;
}

export const useActiveEventStore = create<ActiveEventState>()(
  persist(
    (set) => ({
      activeEventId: null,
      activeEventName: null,
      setActiveEvent: (id, name) =>
        set({ activeEventId: id, activeEventName: name ?? null }),
      clear: () => set({ activeEventId: null, activeEventName: null }),
    }),
    { name: 'ophth-pos.active-event' },
  ),
);

/** Hook returning a stable shape with the event info. */
export function useActiveEvent() {
  const { activeEventId, activeEventName, setActiveEvent, clear } = useActiveEventStore();
  return {
    activeEvent: activeEventId
      ? { id: activeEventId, name: activeEventName ?? '' }
      : null,
    activeEventId,
    activeEventName,
    setActiveEvent: (id: string | null, name?: string) => setActiveEvent(id, name),
    clear,
  };
}
